import { interpret } from 'xstate-v4'
import { rootContainer } from '~/container'
import sentryCapture from '~/utility/sentryCapture'
import { isAbortErrorFromEvent } from '~/utility/isAbortError'
import { langFallback$Fetch } from '../../../lang/utils/langfetch'
import { returnPromoPagesMachine } from './machine'

export function getPromoPagesMachine(langCode: string) {
  return interpret(
    returnPromoPagesMachine().withConfig({
      services: {
        fetch: (_, { slug }) =>
          langFallback$Fetch(langCode, `/_/campsite-promo-pages/${slug}/`),
      },
      actions: {
        // TODO: Add proper type for event parameter instead of any

        logError: (_, event: any) => {
          // Filter out AbortErrors from navigation-based request cancellation
          if (isAbortErrorFromEvent(event)) {
            return
          }

          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          event.data.name = `PromoPagesMachine ${event.type} error`
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          sentryCapture(event.data, rootContainer)
        },
      },
    }),
  )
}
